import * as d3Scale from 'd3-scale';
import styles from './styles.less';
import React from 'react';
import Color from 'color';
import ReactDOM from 'react-dom';
import RcSwitch from 'rc-switch';
import { Popover } from 'react-bootstrap';
import { FormControl } from 'react-bootstrap';
import { Container, Row, Col } from 'react-bootstrap';
import RcSliderBase, { createSliderWithTooltip } from 'rc-slider/lib';
const RcSlider = createSliderWithTooltip(RcSliderBase);
import { ColorPicker as ColorPickerComponent } from '../color-picker';
import Select from 'react-select';

const scales = {
    none: d3Scale.scaleLinear().domain([0, 100]).range([0, 100]),
    log: d3Scale.scaleLog().domain([0.1, 10]).range([0, 100]).clamp(true),
    percent: d3Scale.scaleLinear().domain([0, 1]).range([0, 100]).clamp(true),
};

const tooltipFormatters = {
    log: x => x,
    none: x => x,
    percent: x => `${x}%`
};

function stopPropagation(e) {
    e && e.stopPropagation();
}

export function SettingsList({ id, name, side, loading, style, children = [], ...props } = {}) {
    return (
        <Popover
            id={`${id}-popover`}
            onClick={stopPropagation}
            style={{ ...style, minWidth: `300px` }}
            {...props}>
            <Popover.Title>{name}</Popover.Title>
            <Popover.Content>{children}</Popover.Content>
        </Popover>
    );
}

export function ControlsList({ name, children = [], ...props } = {}) {
    return (
        <Container fluid style={{ padding: 0 }}>
            {name && (
                <Row style={{ margin: 0 }}>
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <p style={{ marginTop: 0 }}>{name}</p>
                    </Col>
                </Row>
            )}
            {children}
        </Container>
    );
}

export function Slider({ id, name, type, props = {}, value = 0, setValue, ...rest } = {}) {
    const { scale = 'none' } = props;
    const tipFormatter = tooltipFormatters[scale];
    value = scales[scale](value);
    if (isNaN(value)) {
        value = props.min || 0;
    }
    console.debug('@slider::render', {id, type, value});
    return (
        <Row className={styles['control-row']}>
            <Col xs={12} sm={12} md={12} lg={12}>
                <Container fluid>
                    <Row>
                        <Col xs={7} sm={7} md={7} lg={7} className={styles['control-label']}>
                            <span>{name}</span>
                        </Col>
                    </Row>
                    <Row className={styles['slider-row']}>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <RcSlider
                                key={`${id}-slider`}
                                min={props.min}
                                max={props.max}
                                step={props.step}
                                defaultValue={value}
                                tipFormatter={tipFormatter}
                                tipProps={{ animation: 'zoom-down' }}
                                onChange={newState =>
                                    setValue({
                                        id,
                                        type,
                                        ...rest,
                                        value: (value = scales[scale].invert(newState))
                                    })}
                                {...rest}
                            />
                        </Col>
                    </Row>
                </Container>
            </Col>
        </Row>
    );
}

export function ToggleButton({ id, name, type, props, value = false, setValue, ...rest } = {}) {
    return (
        <Row className={styles['control-row']}>
            <Col xs={7} sm={7} md={7} lg={7} className={styles['control-label']}>
                <span>{name}</span>
            </Col>
            <Col xs={5} sm={5} md={5} lg={5} className={styles['control']}>
                <RcSwitch
                    key={`${id}-toggle`}
                    defaultChecked={value}
                    checkedChildren={'On'}
                    unCheckedChildren={'Off'}
                    onChange={newState =>
                        setValue({
                            id,
                            type,
                            ...rest,
                            value: (value = newState)
                        })}
                />
            </Col>
        </Row>
    );
}

export function ColorPicker({ id, name, type, props, value = 0, setValue, ...rest } = {}) {
    return (
         <Row className={styles['control-row']}>
            <Col xs={7} sm={7} md={7} lg={7} className={styles['control-label']}>
                <span>{name}</span>
            </Col>
            <Col xs={5} sm={5} md={5} lg={5} className={styles['control']}>
                <ColorPickerComponent
                    color={ new Color(value) }
                    onChange={ ({rgb: { r, g, b, a}}) =>
                        setValue({
                            id,
                            type,
                            ...rest,
                            value: new Color({r,g,b}).alpha(a).toString()
                        }) }
                />
            </Col>
        </Row>
    );
}

export function Dropdown({ id, name, type, props, value, setValue, ...rest} = {}) {
    console.debug('Dropdown::render', {id, name, value});

    const options = Object.keys(props).map(key => ({
        label: props[key],
        value: key
    }));
    const valueOption = options.find(opt => opt.value === value);
    return (
        <Row className={styles['control-row']}>
            <Col xs={12} sm={12} md={12} lg={12}>
                <Container fluid>

                    <Row>
                        <Col xs={7} sm={7} md={7} lg={7} className={styles['control-label']}>
                            <span>{name}</span>
                        </Col>
                    </Row>

                    <Row className={styles['control-row']}>
                        <Col xs={12} sm={12} md={12} lg={12} className={styles['control']}>
                            <Select
                                isDisabled={false}
                                options={options}
                                placeholder={name}
                                id={`dropdown_${id}`}
                                value={valueOption}
                                onChange={(v) => {
                                    const { label, name, value } = v;
                                    console.debug('Dropdown setting', {v, value});
                                    setValue({id, type, value});
                                }}
                                isClearable={false}
                            />
                        </Col>
                    </Row>

                </Container>
            </Col>
        </Row>



   );
}